import { render } from "./XSpinner.vue?vue&type=template&id=c08c1404&scoped=true"
import script from "./XSpinner.vue?vue&type=script&lang=js"
export * from "./XSpinner.vue?vue&type=script&lang=js"

import "./XSpinner.vue?vue&type=style&index=0&id=c08c1404&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c08c1404"]])

export default __exports__